import axios from "axios";
import API from "@/api";
import router from "../router";

const initialState = () => {
  return {
    isLoggedIn: false,
    token: "",
    emailChangeRequested: false,
    new_email: ""
  };
};

const auth = {
  namespaced: true,
  state: initialState(),
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    token: state => state.token,
    emailChangeRequested: state => state.emailChangeRequested,
    new_email: state => state.new_email
  },
  mutations: {
    login(state, { token }) {
      state.isLoggedIn = true;
      state.token = token;
    },
    logout(state) {
      this.commit("certificate/resetState", null, { root: true });
      this.commit("alert/resetState", null, { root: true });
      Object.assign(state, initialState());
    },
    set_emailChangeRequested(state, status) {
      state.emailChangeRequested = status;
    },
    set_newEmail(state, emailAdress) {
      state.new_email = emailAdress;
    }
  },
  actions: {
    async register({ commit }, { password, userDto, userUsageClaim }) {
      commit("startLoading", null, { root: true });
      try {
        return await API.signUp(password, userDto, userUsageClaim);
      } finally {
        commit("stopLoading", null, { root: true });
      }
    },
    async login({ commit }, { email, password }) {
      commit("startLoading", null, { root: true });
      try {
        const response = await API.userLogin(email, password);
        const token = response.data.jwt;
        commit("login", { token });
        return token;
      } finally {
        commit("stopLoading", null, { root: true });
      }
    },
    async refreshToken({ commit, dispatch }) {
      commit("startLoading", null, { root: true });
      try {
        const response = await API.refreshToken();
        const token = response.data.jwt;
        commit("login", { token });
        return token;
      } catch (error) {
        dispatch("logoutSilently");
        router.push("/login");
        throw error;
      } finally {
        commit("stopLoading", null, { root: true });
      }
    },
    async verifyEmailUpdate({ commit, dispatch }, { temporaryToken }) {
      commit("startLoading", null, { root: true });
      try {
        const response = await API.verifyEmailUpdate(temporaryToken);
        const token = response.data.jwt;
        commit("login", { token });
        return token;
      } catch (error) {
        dispatch("logoutSilently");
        throw error;
      } finally {
        commit("stopLoading", null, { root: true });
      }
    },
    async verifyResetPassword({ commit, dispatch }, { passwordResetToken }) {
      commit("startLoading", null, { root: true });
      try {
        const response = await API.verifyResetPassword(passwordResetToken);
        const token = response.data.jwt;
        commit("login", { token });
        return token;
      } catch (error) {
        dispatch("logoutSilently");
        throw error;
      } finally {
        commit("stopLoading", null, { root: true });
      }
    },
    async changePassword({ commit, dispatch }, { newPassword, authToken }) {
      commit("startLoading", null, { root: true });
      try {
        const response = await API.saveResetPassword(newPassword, authToken);
        const token = response.data.jwt;
        commit("login", { token });
        return token;
      } catch (error) {
        dispatch("logoutSilently");
        throw error;
      } finally {
        commit("stopLoading", null, { root: true });
      }
    },
    async resetPassword({ commit }, { email }) {
      commit("startLoading", null, { root: true });
      try {
        return await API.resetPassword(email);
      } finally {
        commit("stopLoading", null, { root: true });
      }
    },
    async deleteOwnUserAccount({ commit, dispatch }) {
      commit("startLoading", null, { root: true });
      try {
        await API.deleteOwnUserAccount();
        await dispatch("logoutSilently");
      } finally {
        commit("stopLoading", null, { root: true });
        router.push("/");
      }
    },
    async logout({ commit, dispatch }) {
      commit("startLoading", null, { root: true });
      try {
        return await API.userLogout();
      } catch (error) {
        // Do nothing
      } finally {
        dispatch("logoutSilently");
        commit("stopLoading", null, { root: true });
        router.push("/login");
      }
    },
    logoutSilently({ commit }) {
      delete axios.defaults.headers.common["Authorization"];
      commit("logout");
    },
    setEmailChangeRequested({ commit }, status) {
      commit("set_emailChangeRequested", status);
    },
    setNewEmail({ commit }, emailAddress) {
      commit("set_newEmail", emailAddress);
    }
  }
};

export default auth;
